export default function Icon({ icon, className }) {
  return (
    <span
      className={`mgc_${icon} icon${className ? ` ${className}` : ""}`}
    ></span>
  );
}
